// Small HUD glyphs for the active cyberware, drawn with 2D canvas paths in one color (so they follow ready/cooldown).
import type { CyberId } from '../../common/src/data';

/** Draw the icon for `id` inside the s x s box at (x, y). Unknown ids get a plain chip. */
export function drawAbilityIcon(g: CanvasRenderingContext2D, id: CyberId, x: number, y: number, s: number, color: string) {
  g.save(); g.translate(x, y); g.scale(s / 10, s / 10); g.fillStyle = color; g.strokeStyle = color; g.lineWidth = 1;
  if (id === 'kagemusha_decoy') {
    // a solid figure and its hologram echo (hollow, with scanlines) running off to the right
    g.beginPath(); g.arc(3, 2.6, 1.6, 0, Math.PI * 2); g.fill(); g.fillRect(1.6, 4.6, 2.8, 4.4);
    g.globalAlpha = 0.65; g.strokeRect(6.1, 4.1, 3.3, 5); g.beginPath(); g.arc(7.75, 2.2, 1.5, 0, Math.PI * 2); g.stroke();
    g.fillRect(6.1, 5.9, 3.3, 0.7); g.fillRect(6.1, 7.7, 3.3, 0.7);
  } else if (id === 'reflex_accelerator') {
    g.beginPath(); g.moveTo(6, 0); g.lineTo(2, 5.6); g.lineTo(4.8, 5.6); g.lineTo(3.6, 10); g.lineTo(8, 4); g.lineTo(5.2, 4); g.closePath(); g.fill();
  } else if (id === 'vault_legs') {
    g.beginPath(); g.moveTo(1, 7); g.lineTo(5, 1.5); g.lineTo(9, 7); g.lineTo(7, 7); g.lineTo(5, 4.4); g.lineTo(3, 7); g.closePath(); g.fill(); g.fillRect(1, 8.4, 8, 1.4);
  } else g.fillRect(1.5, 1.5, 7, 7);
  g.restore();
}
